import { gql, TypedDocumentNode } from '@apollo/client';

import {
  LoginMutation,
  LoginMutationVariables,
  RegisterMutation,
  RegisterMutationVariables,
  LogoutMutation,
  LogoutMutationVariables,
  RefreshAccessTokenMutation,
  RefreshAccessTokenMutationVariables,
} from '../generated';

export const REFRESH_ACCESS_TOKEN: TypedDocumentNode<
  RefreshAccessTokenMutation,
  RefreshAccessTokenMutationVariables
> = gql`
  mutation RefreshAccessToken {
    refreshAccessToken {
      user {
        id
        email
      }
    }
  }
`;

export const LOGIN: TypedDocumentNode<LoginMutation, LoginMutationVariables> =
  gql`
    mutation Login($input: LoginInput!) {
      login(input: $input) {
        user {
          id
          email
        }
      }
    }
  `;

export const REGISTER: TypedDocumentNode<
  RegisterMutation,
  RegisterMutationVariables
> = gql`
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      user {
        id
        email
      }
    }
  }
`;

export const LOGOUT: TypedDocumentNode<
  LogoutMutation,
  LogoutMutationVariables
> = gql`
  mutation Logout {
    logout {
      success
    }
  }
`;
